import debug from "./debug";

const Run = {

    LAUNCHER_COMMON_CONTROLLER: 'Common',
    LAUNCHER_INIT_ACTION: 'init',
    namespace: null,

    exec: function( controller, action ) {

        const _action = (
            typeof action === 'undefined'
                ? this.LAUNCHER_INIT_ACTION
                : action
        );

        if(typeof controller !== 'undefined')
        {
            if (typeof this.namespace[_action] === "function") {
                // console.info("Run.exe #1 - ", { "controller" : controller, "action" : _action } );
                this.namespace[_action]();
            }

            else if (this.namespace[controller] &&
                typeof this.namespace[controller][_action] === "function") {
                // console.info("Run.exe #2", { "controller" : controller, "action" : _action } );
                this.namespace[controller][_action]();
            }

            else {
                // console.warn("Run.exe #3", { "controller" : controller, "action" : _action } );
            }
        }
    },

    init: function(namespace) {

        this.namespace = namespace;
        const body = document.body;
        const controller = body.getAttribute("data-controller");
        const action = body.getAttribute("data-action");

        debug.log("run.init - controller", controller, "action", action);

        this.exec(this.LAUNCHER_COMMON_CONTROLLER);
        this.exec(controller);
        this.exec(controller, action);
    }
};

export default Run;

